import { render, staticRenderFns } from "./agentBgdRecharge.vue?vue&type=template&id=e5e44abc&scoped=true&"
import script from "./agentBgdRecharge.vue?vue&type=script&lang=js&"
export * from "./agentBgdRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e44abc",
  null
  
)

export default component.exports